import React from 'react';
import './BannerNewsAndSocialMedia.scss';
import { Icon } from 'antd';
import { FormattedMessage } from 'react-intl';
import Button from 'Components/Shared/Button/Button';
import FormattedText from 'Components/Shared/FormattedText/FormattedText';

export enum Feedback {
  NONE,
  SUBSCRIPTION_SUCCESS,
  SUBSCRIPTION_FAILED,
};

interface IProps {
  feedback: Feedback,
  urlFacebook: string;
  newsLetterContent: Julius.Content.Banner;
  socialMediaContent: Julius.Content.Banner;
  onEmailChange: (e: React.FormEvent<HTMLInputElement>) => void;
  onSubscriptionSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
}

const BannerNewsAndSocialMedia: React.SFC<IProps> = ({
  feedback,
  urlFacebook,
  newsLetterContent,
  socialMediaContent,
  onEmailChange,
  onSubscriptionSubmit,
}) => {

  if (!newsLetterContent || !socialMediaContent) {
    return null;
  }

  const SubscriptionSuccess = () => (
    <FormattedText 
      style='feedback success'
      displayName={
        `Vi kommer att meddela dig om senaste nytt och 
        erbjudanden från oss och våra arrangörer!`
      }
      formattedName='user.message.subscription.success'
    />
  );

  const SubscriptionFailure = () => (
    <FormattedText 
      style='feedback failed'
      displayName={
        `Just nu gick det inte att skriva upp dig som prenumerant 
        på vårt nyhetsbrev. Försök gärna igen om en stund.`
      }
      formattedName='user.message.subscription.failed'
    />
  );

  return (
    <div className='banner-news-socialmedia'>
      <Box { ...newsLetterContent } place='left'>
        <form onSubmit={ onSubscriptionSubmit }>
          <FormattedMessage 
            id='placeholder.email'
            defaultMessage='Ange din e-post'>
            {
              (placeholderString: string) =>
              <input 
                type="email"
                placeholder={ placeholderString }
                onChange={ onEmailChange }
              />
            }
          </FormattedMessage>
          <Button color='black' type='submit'>
            <Icon type='mail' />
            <FormattedText
              displayName='Skicka'
              formattedName='global.send'
            />
          </Button>
        </form>
        { feedback === Feedback.SUBSCRIPTION_SUCCESS && <SubscriptionSuccess /> }
        { feedback === Feedback.SUBSCRIPTION_FAILED && <SubscriptionFailure /> }
      </Box>
      <Box { ...socialMediaContent } place='right'>
        <Button redirectUrl={ urlFacebook } color='black' extraRadius={ true }>
          <Icon type='facebook' />
          <FormattedText
            displayName='Följ & gilla oss'
            formattedName='global.followandlike'
          />
        </Button>
      </Box>
    </div>
  );
}

const Box: React.SFC<{
  title: string;
  text: string;
  imageUrl: string;
  place: 'left' | 'right';
}> = ({
  title,
  text,
  imageUrl,
  place,
  children,
}) =>  (
  <div className={ `box ${ place }` } style={ { backgroundImage: `url(${ imageUrl })` } }>
    <div className='mask'>
      <div className='content'>
        <span className='title'>{ title }</span>
        <span className='text' dangerouslySetInnerHTML={ { __html: text } } />
        { children }
      </div>
    </div>
  </div>
);

export default BannerNewsAndSocialMedia;


// WEBPACK FOOTER //
// ./src/components/BannerNewsAndSocialMedia/BannerNewsAndSocialMedia.tsx